import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = [
    "data-active"
];
const _hoisted_2 = {
    class: "biz-area_label"
};
const _hoisted_3 = {
    key: 0,
    class: "biz-area_arrow",
    name: "up-f"
};
const _hoisted_4 = {
    key: 1,
    class: "biz-area_arrow",
    name: "down-f"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Doption = _resolveComponent("Doption");
    const _component_Dropdown = _resolveComponent("Dropdown");
    return _openBlock(), _createBlock(_component_Dropdown, {
        position: "bl",
        onSelect: _ctx.handleChangeLessee,
        onPopupVisibleChange: _ctx.handleActiveStatusChange
    }, {
        content: _withCtx(()=>[
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bizAreaList, (item)=>{
                    return _openBlock(), _createBlock(_component_Doption, {
                        key: item.value,
                        value: item.value,
                        style: _normalizeStyle({
                            minWidth: '112px',
                            color: item.value === _ctx.curLesseeInfo.lesseeCode ? 'var(--color-primary)' : undefined
                        })
                    }, {
                        default: _withCtx(()=>[
                                _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                        _: 2
                    }, 1032, [
                        "value",
                        "style"
                    ]);
                }), 128))
            ]),
        default: _withCtx(()=>[
                _createElementVNode("div", {
                    class: "biz-area_wrapper",
                    "data-active": _ctx.isActive
                }, [
                    _cache[0] || (_cache[0] = _createElementVNode("pg-icon", {
                        class: "biz-area_icon",
                        name: "international"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.curLesseeInfo.lesseeBizAreaName || _ctx.curLesseeInfo.lesseeBizArea || _ctx.curLesseeInfo.lesseeName || ''), 1),
                    _ctx.isActive ? (_openBlock(), _createElementBlock("pg-icon", _hoisted_3)) : (_openBlock(), _createElementBlock("pg-icon", _hoisted_4))
                ], 8, _hoisted_1)
            ]),
        _: 1
    }, 8, [
        "onSelect",
        "onPopupVisibleChange"
    ]);
}
